import { Card, CardBody, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';

export const OnHandQty = ({ Item, data, onClose }: { Item: any; data: any; onClose: any }) => {
  const { t, i18n } = useTranslation();

  const n = (v: any) => {
    const x = Number(v);
    return Number.isFinite(x) ? x : 0;
  };

  const row =
    (data || []).find(
      (f: any) =>
        String(f?.itemId) === String(Item?.transactionItemId) &&
        String(f?.unitOfMeasure) === String(Item?.transactionUom)
    ) || (data || []).find((f: any) => String(f?.itemId) === String(Item?.transactionItemId));

  const isEn = i18n.language === 'en';
  const itemName = (isEn ? row?.name || row?.name2 : row?.name2 || row?.name) || '';

  const lots = Array.isArray(row?.qtyByLot) ? row.qtyByLot : [];
  const lotAvailable = (lot: any) => Math.max(0, n(lot?.qty) - n(lot?.reservationQty));

  const sumLots = lots.reduce((s: number, x: any) => s + lotAvailable(x), 0);
  const sumReservedLots = lots.reduce((s: number, x: any) => s + n(x?.reservationQty), 0);

  const invAvail = Math.max(0, n(row?.quentity) - n(row?.reservedQty));

  const showLots = lots.length > 0;

  return (
    <Card className='shadow-lg'>
      <CardHeader className='bg-theme bg-opacity-10 p-2 text-center'>
        <h5 className='m-0'>
          <i className='fas fa-box me-2'></i>
          {itemName}
        </h5>
      </CardHeader>

      <CardBody className='p-4'>
        <div className='row mb-4'>
          <div className='col-md-6 mb-3 mb-md-0'>
            <Card>
              <div className='border-success h-100'>
                <div className='card-body text-center'>
                  <h6 className='card-title text-muted'>{t('AvailableQuantity')}</h6>
                  <h3 className='text-success fw-bold'>{showLots ? sumLots : invAvail}</h3>
                </div>
              </div>
            </Card>
          </div>

          <div className='col-md-6'>
            <Card>
              <div className='border-danger h-100'>
                <div className='card-body text-center'>
                  <h6 className='card-title text-muted'>{t('ReservedQuantity')}</h6>
                  <h3 className='text-danger fw-bold'>{showLots ? sumReservedLots : n(row?.reservedQty)}</h3>
                </div>
              </div>
            </Card>
          </div>
        </div>

        {showLots && (
          <div className='mt-4'>
            <div className='d-flex align-items-center mb-3'>
              <div className='flex-grow-1'>
                <hr />
              </div>
              <h5 className='px-3 mb-0 text-center text-theme'>{t('InventoryDetails')}</h5>
              <div className='flex-grow-1'>
                <hr />
              </div>
            </div>

            <div className='table-responsive'>
              <table className='table table-hover'>
                <thead className='bg-theme bg-opacity-20'>
                  <tr>
                    <th>
                      <i className='fas fa-barcode me-1'></i> {t('LotNumber')}
                    </th>
                    <th>
                      <i className='fas fa-box me-1'></i> {t('Quantity')}
                    </th>
                    <th>
                      <i className='fas fa-calendar-alt me-1'></i> {t('ExpirationDate')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {lots.map((lot: any) => (
                    <tr key={lot.lotId ?? lot.lotNumber}>
                      <td>
                        <strong>{lot.lotNumber || t('None')}</strong>
                      </td>
                      <td>
                        <span className='badge bg-theme fs-6'>{lotAvailable(lot)}</span>
                      </td>
                      <td>
                        <span className={lot?.expirationDate ? 'text-dark' : 'text-muted'}>
                          {lot?.expirationDate ? String(lot.expirationDate).split('T')[0] : t('None')}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div className='d-grid mt-4'>
          <button type='button' className='btn btn-outline-secondary btn-lg rounded-0' onClick={onClose}>
            <i className='fas fa-times-circle me-2'></i>
            {t('Cancel')}
          </button>
        </div>
      </CardBody>
    </Card>
  );
};
